// src/components/EditVibeMainPage.js
import React, { useState } from 'react';
import './EditVibeMainPage.css';
import logo from '../assets/Editvibelogo1.svg';
import editvibe95 from '../assets/editvibe95.png';
import aifinish from '../assets/aifinish.png';
import complicatedai from '../assets/complicatedai.png';
import timelinesample from '../assets/timelinesample.png';
import editvibecut from '../assets/editvibecut.png';
import promoVideo from '../assets/EditVibeVideo.webm';
import sectionVideo from '../assets/EditVibesection.webm';
import { Link } from 'react-router-dom';

const faqItems = [
  { question: 'How does EditVibe’s fully automated editing process actually work?', answer: 'Upload your raw footage (up to 10 min), type in a simple prompt describing what you want, and let our AI model handle everything, from cuts, pacing, music and sound effects' },
  { question: 'Which EditVibe model should I choose, EditVibe95 or EditVibe‑CUT?', answer: 'EditVibe-95 (Research Preview) delivers end‑to‑end full edits for up to 10 min of footage. EditVibe-CUT is perfect for precision trims—remove words, phrases or time‑coded sections.' },
  { question: 'How long will my video take to process?', answer: 'Processing time varies by model. EditVibe‑95: Runs a full, multi‑stage neural pipeline, covering shot detection, seamless inpainting, music selection, audio mixing, and style transfer. As a result, a 10‑minute video generally takes several hours, and in some cases up to 24 hours for the highest‑fidelity output. EditVibe‑CUT is designed for quick trims, it typically completes segment removals in seconds to a few minutes.' },
  { question: 'Can I upload any kind of video?', answer: `You may upload most common video formats, but all content must comply with our Terms of Service and Community Guidelines. Disallowed material includes (but is not limited to):
- Sexually explicit or pornographic content
- Graphic violence or gore
- Hate speech, harassment, or threats
- Illegal activities (e.g. drug manufacture, copyright infringement)

By uploading, you certify that you own (or have permission to use) all rights in the content and that it does not violate any laws or third‑party rights.
If we detect or receive a valid complaint about prohibited content, we reserve the right to:
1. Remove the video immediately
2. Suspend or terminate your account
3. Report the content or your account to law enforcement or other authorities

For full details, please see our Terms of Service and Privacy Policy.` },
  { question: 'Is EditVibe free to use?', answer: 'Every new account receives 1,150 credits to get started enough to try both EditVibe‑95 for full edits and EditVibe‑CUT for precision trims. Once you’ve used your free credits, you can choose from our paid membership plans for additional credits.' },
  { question: 'I have more questions!', answer: (<p>Feel free to <a href="mailto:info@editvibe.ai">Contact Us</a> and we’ll be happy to answer any additional questions you have!</p>) }
];

const EditVibeMainPage = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);      // ← add this line
  const toggleFaq = index => setOpenIndex(openIndex === index ? null : index);

  // helper to redirect externally
  const goToApp = () => {
    window.location.href = 'https://app.editvibe.ai';
  };

  return (
    <div className="evmp-mainpage">

      <header className="evmp-header">
      <div className="evmp-header-inner">
          <img src={logo} alt="EditVibe Logo" className="evmp-logo" />

          {/* 1) add this button */}
          <button
            className="evmp-mobile-toggle"
            onClick={() => setMobileMenuOpen(open => !open)}
            aria-label="Toggle menu"
          >☰</button>

          {/* 2) update this nav */}
          <nav className={`evmp-nav ${mobileMenuOpen ? 'open' : ''}`}>
            <a href="#features">Features</a>
            <a href="#solutions">Solutions</a>

        
            <a
    href="#articles"
    className="evmp-link-disabled"
    onClick={e => e.preventDefault()}
  >
    Articles
  </a>
             
            <a href="#faq">FAQ</a>
            <button
              className="evmp-btn evmp-btn-primary evmp-btn-moema"
              onClick={goToApp}
            >
              Get Started
            </button>
          </nav>
        </div>
      </header>

      <section className="evmp-hero">
        <h1>Automated AI Video Editing Made Simple</h1>
        <p>Upload your footage, and get back a fully edited video. No editing software, no hassle our AI handles everything from cuts to polish.</p>
        <div className="evmp-hero-cta">
          <button
            className="evmp-btn evmp-btn-cta evmp-btn-moema"
            onClick={goToApp}
          >
            Try EditVibe For Free
          </button>
        </div>
        <div className="evmp-hero-video-container">
          <video className="evmp-hero-video" autoPlay muted loop playsInline>
            <source src={promoVideo} type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>

      <section className="evmp-sell">
        <h2 className="evmp-sell-title">
        Upload. Relax. Get a Fully Edited Video{' '}
          <span className="evmp-sell-highlight">EditVibe AI</span>
        </h2>
        <p className="evmp-sell-subtitle">
          With EditVibe, you don’t edit no timelines, no confusing software. Just upload your video, EditVibe’s AI handles the editing from start to finish, cuts, pacing, music and flow  all done automatically, so you can focus on creating, not cutting.
        </p>
        <button className="evmp-btn evmp-btn-sell evmp-btn-moema">
          Try EditVibe For Free
        </button>
      </section>

      <section className="evmp-promo">
        <video
          className="evmp-promo-bg"
          src={sectionVideo}
          type="video/webm"
          autoPlay
          muted
          loop
          playsInline
        />
        <div className="evmp-promo-overlay" />
        <div className="evmp-promo-content">
          {/* ...logo, button, text... */}
        </div>
      </section>



      <section id="features" className="evmp-subtitles">
  <div className="evmp-subtitles-content">
    <div className="evmp-subtitles-text">
      <h2>EditVibe-95 Model</h2>
      <p>
      EditVibe-95 is our latest breakthrough model designed to fully automate the video editing process no manual timelines, no editing software, no complex workflows.
      Just upload your footage, describe your vision, and EditVibe-95 handles everything.This model is currently in Research Preview as we continue to rapidly refine its capabilities, improving video processing speeds, and expand its creative range. We’re actively improving EditVibe-95 based on real-world use to push the boundaries of fully automated AI video editing.
      </p>
    </div>
    <div className="evmp-subtitles-image">
    <img src={editvibe95} alt="EditVibe Logo" />
    </div>
  </div>
</section>

<section className="evmp-subtitles-reversed">
  <div className="evmp-subtitles-content-reversed">
    <div className="evmp-subtitles-image-reversed">
      <img src={editvibecut} alt="EditVibe Logo" />
    </div>
    <div className="evmp-subtitles-text-reversed">
      <h2>EditVibe-CUT Model</h2>
      <p>
      EditVibe-CUT makes video editing faster and easier by allowing you to remove unwanted sections with simple prompts or timecodes.
Whether you want to cut the moment someone says a specific word like: Remove the part where the speaker says "I think I messed that up" or trim precise seconds (e.g., from 00:12 to 00:15), EditVibe-CUT puts full control in your hands without ever opening a timeline.
This model focuses on audio and timing-based edits. It does not yet support visual scene recognition, but that capability is coming soon with EditVibe-CUT2, which will enable cutting based on visual content as well.
      </p>
    </div>
  </div>
</section>

<section id="solutions" className="evmp-details">
        <h2 className="evmp-details-title">Why EditVibe AI Is Different</h2>
        <div className="evmp-details-cards">
          <div className="evmp-detail-card">
            <div className="evmp-detail-image">
            <img src={aifinish} alt="AI curation" />
            </div>
            <h3>AI That Finishes the Job</h3>
            <p>EditVibe’s AI doesn’t just clip highlights, it edits full videos from start to finish, handling cuts, pacing, and polish automatically.</p>
          </div>
          <div className="evmp-detail-card">
            <div className="evmp-detail-image">
            <img src={complicatedai} alt="Animated captions" />
            </div>
            <h3>Effortless Workflow</h3>
            <p>Skip the complicated timelines and manual tools. With EditVibe, simply upload your footage, describe your vision, and get a fully edited video back.</p>
          </div>
          <div className="evmp-detail-card">
            <div className="evmp-detail-image">
              <img src={timelinesample} alt="AI reframe" />
            </div>
            <h3>No Editing Software. No Learning Curve.</h3>
            <p>EditVibe replaces complex editing tools entirely, no downloads, no timelines, no tutorials. Upload your footage, describe your goal, and get a finished video without ever touching editing software.</p>
          </div>
        </div>
      </section>

      <section id="faq" className="evmp-faq">
        <h2 className="evmp-faq-title">Got questions?</h2>
        <div className="evmp-faq-list">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className={`evmp-faq-item ${openIndex === idx ? 'open' : ''}`}
              onClick={() => toggleFaq(idx)}
            >
              <div className="evmp-faq-question">
                {item.question}
                <span className="evmp-faq-arrow" />
              </div>
              <div className="evmp-faq-answer">{item.answer}</div>
            </div>
          ))}
        </div>
      </section>

      

      <footer className="evmp-footer">
        <div className="evmp-footer-col">
          <h4>Company</h4>
          <Link to="/about">About</Link>
        </div>
        <div className="evmp-footer-col">
          <h4>Product</h4>
          <a href="#features">Features</a>
        </div>
        <div className="evmp-footer-col">
    <h4>Resources</h4>
    <span className="evmp-footer-disabled">Articles</span>
  </div>
        <div className="evmp-footer-col">
          <h4>Support</h4>
          <a href="mailto:info@editvibe.ai">Contact Us</a>
        </div>
      </footer>
    </div>
  );
};

export default EditVibeMainPage;
